import React from 'react'
import {
  Box,
  Button,
  FormControl,
  Grid,
  Modal,
  TextField,
} from '@material-ui/core'
import { FilePdfOutlined } from '@ant-design/icons'
import { message, Upload } from 'antd'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import swal from 'sweetalert'
import { insertAzureBlobStorageService } from '../../../../../services/AsistenciaTecnica/create'
import { useAuthentication } from '../../../../../context/authenticationContext'
const { Dragger } = Upload

export const Modal2 = ({
  open,
  setOpen,
  IdReportAnswer,
  getAttachedDocumentsList,
  RelatedFormField,
}) => {
  const { userIDB2C } = useAuthentication()

  const GeneralDataSchema = Yup.object().shape({
    FileContents: Yup.string().required('Tiene que subir un arhivo PDF'),
    Description: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#./\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(100, 'Máximo 100 caracteres'),
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: {
      FileContents: '',
      FileExtension: '',
      FileName: '',
      Description: '',
      SizeMB: 0,
      IdForm: IdReportAnswer,
      IdUser: userIDB2C,
      RelatedFormField: RelatedFormField,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values)``
    },
  })

  const saveForm = async (values) => {
    const response = await insertAzureBlobStorageService(values)

    if (response.Success) {
      swal({
        title: '¡Datos guardados exitosamente!',
        icon: 'success',
      })
      getAttachedDocumentsList()
      handleClose()
    }
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title:
        'Favor validar: Si el archivo cumple con los requisitos o si hay campos pendientes por completar.',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleClose = () => {
    setOpen(false)
    formik.resetForm()
  }

  const props = {
    name: 'file',
    maxCount: 1,
    // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    multiple: false,
    beforeUpload: (file) => {
      const isPNG = file.type === 'application/pdf'

      // if (!isPNG) {
      //   message.error(`Solo se permiten archivos PDF`)
      // }

      const isLt4M = file.size / 1024 / 1024 < 4
      // if (!isLt4M) {
      //   message.error(`El archivo es mayor que 4 MB`)
      //   swal({
      //     title: 'El archivo es mayor que 4 MB',
      //     icon: 'warning',
      //     button: 'Entendido',
      //   })
      // }

      // return isPNG && isLt4M ? false : true
      // return false
      if (!isPNG && !isLt4M) {
        return true
      } else {
        return false
      }
    },
    onChange(info) {
      const { status } = info.file
      if (status === 'removed') {
        formik.resetForm()
      }

      // formik.resetForm()

      if (status !== 'uploading') {
        console.log('')
      }
      if (status === undefined) {
        // message.success(`${info.file.name} archivo cargado exitosamente.`)
        const marker = 1024
        const megaBytes = marker * marker
        const sizeMB = Number((info.file.size / megaBytes).toFixed(2))
        const isPNG = info.file.type === 'application/pdf'
        if (sizeMB > 4) {
          message.error(`El archivo es mayor que 4 MB`)
          swal({
            title: 'El archivo es mayor que 4 MB',
            icon: 'warning',
            button: 'Entendido',
          })
        } else if (!isPNG) {
          message.error(`Solo se permiten archivos PDF`)
        } else {
          blobToBase64(info.file).then((res) => {
            formik.setFieldValue('FileContents', res, true)
          })
          message.success(`${info.file.name}  archivo cargado exitosamente.`)
          formik.setValues({
            ...formik.values,
            SizeMB: sizeMB,
            FileName: info.file.name,
          })
        }
      } else if (status === 'error' || status === 'done') {
        formik.resetForm()
        // message.error(`${info.file.name} file upload failed.`)

        console.log('error ')
        // const marker = 1024
        // const megaBytes = marker * marker
        // const sizeMB = Number((info.file.size / megaBytes).toFixed(2))
        // if (sizeMB > 4) {
        //   message.error(`El archivo es mayor que 4 MB`)
        //   swal({
        //     title: 'El archivo es mayor que 4 MB',
        //     icon: 'warning',
        //     button: 'Entendido',
        //   })
        // } else {
        //   message.success(`${info.file.name}  archivo cargado exitosamente.`)
        //   formik.setValues({
        //     ...formik.values,
        //     SizeMB: sizeMB,
        //     FileName: info.file.name,
        //   })
        // }
      }
    },
    // onChange(info) {
    //   const { status } = info.file

    //   if (status === 'removed') {
    //     formik.resetForm()
    //   }

    //   // formik.resetForm()

    //   if (status !== 'uploading') {
    //     console.log('')
    //   }
    //   if (status === 'sucess') {
    //     message.success(`${info.file.name} archivo cargado exitosamente.`)
    //   } else if (status === 'error' || status === 'done') {
    //     // message.error(`${info.file.name} file upload failed.`)

    //     const marker = 1024
    //     const megaBytes = marker * marker
    //     const sizeMB = Number((info.file.size / megaBytes).toFixed(2))
    //     if (sizeMB > 4) {
    //       message.error(`El archivo es mayor que 4 MB`)
    //       swal({
    //         title: 'El archivo es mayor que 4 MB',
    //         icon: 'warning',
    //         button: 'Entendido',
    //       })
    //     } else {
    //       message.success(`${info.file.name}  archivo cargado exitosamente.`)
    //       formik.setValues({
    //         ...formik.values,
    //         SizeMB: sizeMB,
    //         FileName: info.file.name,
    //       })
    //     }
    //   }
    // },
    onDrop(e) {
      formik.resetForm()
    },
  }

  const blobToBase64 = (blob) => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result.toString().replace(/^data:(.*,)?/, ''))
      }
    })
  }

  // const configValue = (res) => {
  //   console.log('viendo el archivo desde el value', res)
  //   // formik.setFieldValue('FileContents', res)
  //   formik.setValues({
  //     ...formik.values,
  //     FileContents: res,
  //   })
  // }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalPYME">
          <div className="pymeDiv">
            <h1 className="pymeTitle">Carga de archivo</h1>
          </div>

          <Grid container spacing={1} className="input__container">
            <Grid item xs={12} sm={8} md={8}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Nombre archivo</label>
              </Grid>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: 220 }}
                  disabled
                  value={formik.values.FileName}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">Tamaño</label>
              </Grid>
              <FormControl style={{ width: '100%' }}>
                <TextField
                  id="MiPymeCountry"
                  name="MiPymeCountry"
                  type="text"
                  variant="outlined"
                  sx={{ width: 220 }}
                  disabled
                  value={formik.values.SizeMB + ' ' + 'MB'}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Descripción <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <FormControl style={{ width: '100%' }}>
                <textarea
                  id="ClimateThreat"
                  customInput={TextField}
                  value={formik.values.Description}
                  onChange={(e) => {
                    formik.setFieldValue('Description', e.target.value)
                  }}
                ></textarea>
                {formik.errors.Description ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.Description}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
            <Grid container spacing={1} className="input__container">
              <Grid item xs={12} sm={12} md={12}>
                <Dragger {...props}>
                  <p className="ant-upload-drag-icon">
                    <FilePdfOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Haga clic o arrastre aquí para seleccionar un archivo
                  </p>
                  <p className="ant-upload-hint">
                    Tamaño máximo archivo: <strong>4 MB</strong>{' '}
                  </p>
                </Dragger>
              </Grid>
              <Grid container spacing={1} className="input__container">
                <Grid item xs={12} sm={12} md={12}>
                  {formik.errors.FileContents ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.FileContents}
                    </div>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={1} className="input__container">
              <Grid className="buttonsPYME" style={{ marginTop: '3%' }}>
                <Button className="cancelButton" onClick={handleClose}>
                  Cancelar
                </Button>
                <Button
                  className="confirmButton"
                  type="button"
                  onClick={validateFormStatus}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  )
}
